import { render, staticRenderFns } from "./AdminWidget.vue?vue&type=template&id=f78df36a"
import script from "./AdminWidget.vue?vue&type=script&lang=js"
export * from "./AdminWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports